import { useQuery } from "@tanstack/react-query";
import { inboxApi } from "./api";
import { inboxKeys } from "./hooks";
import { useInboxToken } from "./useInboxToken";

// Lookup-only check used outside the inbox (e.g. the "Open conversation"
// button on a lead page) to know whether a contact already has a conversation.
// Returns null when none exists (getConversationByContact swallows the 404).
// Fetches the inbox auth token itself — outside the inbox no one else does,
// and the inbox client rejects requests until the token is in the cache.
export const useConversationByContact = (
  contactId?: number,
  options?: { refetchInterval?: number }
) => {
  const { accessToken } = useInboxToken();

  return useQuery({
    queryKey: [...inboxKeys.contacts(), contactId, "CONVERSATION"],
    queryFn: () => inboxApi.getConversationByContact(contactId!),
    enabled: !!contactId && !!accessToken,
    // Poll for unread updates when used as a live badge outside the inbox.
    refetchInterval: options?.refetchInterval
  });
};
